import React, {
  useEffect, useState, Fragment,
} from 'react';
import _ from 'lodash';
import {
  usePaginatedQuery, ErrorHandler, InfiniteScrollComponent,
} from '@playbookux/playbook-web-core';
import EventsModal from '../../components/events-modal';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';
import ParticipantsSource from '../../../core/constants/participantsSource';
import { GET_APPROVALS, LIMIT } from './graphql';

import {
  Column,
  ColumnText,
  Container,
  Divider,
  Grid,
  Row,
  Menu,
  ContainerMenu,
  MenuItem,
  Loader,
} from './styles';

import { COLUMN_TITLES } from './constants';
import Approval from './approval/index';
import { registerFunctions } from '../../../core/hooks/use-function-handler';

const Approvals = () => {
  const [activeItem, setActiveItem] = useState(ParticipantsSource.PLAYBOOK);
  const [approvalsLength, setApprovalsLength] = useState(LIMIT);

  const handleItemClick = (e, { name }) => {
    setActiveItem(name);
  };

  const [currentTester, setCurrentTester] = useState(undefined);
  const handleSetCurrentTestSession = (ts) => {
    setCurrentTester(ts);
  };

  const handleModalClose = () => {
    setCurrentTester(undefined);
  };

  const attributes = {
    variables: {
      limit: approvalsLength,
      offset: 0,
      participantSource: [activeItem],
    },
  };

  const {
    error,
    data = {},
    fetchMore,
    hasMore,
    refetch,
  } = usePaginatedQuery(GET_APPROVALS, attributes, { dataField: 'approvals' });

  const { approvals = [] } = data;

  const onRefetch = () => {
    refetch({ limit: approvalsLength, offset: 0, participantSource: [activeItem] });
  };

  useEffect(() => {
    if (approvals.length !== 0) {
      setApprovalsLength(approvals.length);
    }
  }, [approvals]);

  const handleEvent = () => {
    refetch.call();
  };

  // the group approvals is for when project launched OR the name of the project is updated (NOT CREATED)
  registerFunctions('approvals', {
    func1: handleEvent,
  });

  if (error) {
    return (
      <ErrorHandler
        error={error}
        defaultMessage="Error while retrieving approvals."
      />
    );
  }

  return (
    <Container>
      <ContainerMenu>
        <Menu secondary>
          <MenuItem
            name={ParticipantsSource.PLAYBOOK}
            active={activeItem === ParticipantsSource.PLAYBOOK}
            onClick={handleItemClick}
          >
            PlaybookUX Participants
          </MenuItem>
          <MenuItem
            name={ParticipantsSource.COMPANY}
            active={activeItem === ParticipantsSource.COMPANY}
            onClick={handleItemClick}
          >
            Bring your own participants
          </MenuItem>
        </Menu>
      </ContainerMenu>

      {(approvals.length === 0) ? (
        <Loader data-loader="approvals-loader" />
      ) : (
        <InfiniteScrollComponent
          useWindow
          hasMore={hasMore}
          onLoadMore={fetchMore}
        >
          <Grid columns={5}>
            <Row>
              {COLUMN_TITLES.map((columnsTitle) => (
                <Column key={columnsTitle.id} width={columnsTitle.width}>
                  <ColumnText>
                    {columnsTitle.title}
                  </ColumnText>
                </Column>
              ))}
            </Row>
          </Grid>
          {approvals.map(({ project, approvalTypes }, index) => (
            <Fragment key={`${project.id}-${approvalTypes[index]}`}>
              {approvalTypes.map((approvalType) => (
                <Approval
                  key={`${project.id}-${approvalType}`}
                  approvalType={approvalType}
                  activeItem={activeItem}
                  project={project}
                  onSetCurrentTester={handleSetCurrentTestSession}
                  refetch={onRefetch}
                />
              ))}
              {!_.isEmpty(approvalTypes) && <Divider />}
            </Fragment>
          ))}
        </InfiniteScrollComponent>
      )}

      <EventsModal
        tester={currentTester}
        open={!!currentTester}
        onClose={handleModalClose}
      />
    </Container>
  );
};

Approvals.propTypes = {};

export default withDashboardSidebar(Approvals);
